import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const linkCls = ({ isActive }) =>
  `font-type text-[0.7rem] uppercase tracking-[0.18em] py-1 border-b transition-colors ${isActive ? "border-[#C84B31] text-[#121210]" : "border-transparent text-[#5C584E] hover:text-[#C84B31]"}`;

function Links({ user, onClick }) {
  return (
    <>
      <NavLink to="/discover" className={linkCls} onClick={onClick} data-testid="nav-discover-link">Discover</NavLink>
      {user && <NavLink to="/dashboard" className={linkCls} onClick={onClick} data-testid="nav-dashboard-link">Your desk</NavLink>}
      {user && <NavLink to="/settings" className={linkCls} onClick={onClick} data-testid="nav-settings-link">Profile</NavLink>}
      {user?.is_admin && <NavLink to="/admin" className={linkCls} onClick={onClick} data-testid="nav-admin-link">Admin</NavLink>}
    </>
  );
}

export default function Nav() {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const out = async () => {
    await logout();
    navigate("/");
  };
  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-[#FDFBF7]/90 border-b border-[#E5DEC9]" data-testid="site-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-baseline gap-3" data-testid="nav-brand-link">
          <span className="font-display text-2xl tracking-tight">Author<span className="italic text-[#C84B31]">OS</span></span>
          <span className="hidden sm:inline label-mono">indie Press</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          <Links user={user} />
          {user ? (
            <button className="btn-ghost" onClick={out} data-testid="nav-logout-button">Sign out</button>
          ) : (
            <Link to="/signin" className="btn-primary !py-2 !px-4" data-testid="nav-signin-button">Sign in</Link>
          )}
        </nav>
        <button className="md:hidden p-2" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#E5DEC9] px-6 py-5 flex flex-col gap-4 bg-[#FDFBF7]" data-testid="nav-mobile-menu">
          <Links user={user} onClick={() => setOpen(false)} />
          {user ? (
            <button className="btn-secondary w-full" onClick={out} data-testid="nav-mobile-logout-button">Sign out</button>
          ) : (
            <Link to="/signin" className="btn-primary w-full" onClick={() => setOpen(false)} data-testid="nav-mobile-signin-button">Sign in</Link>
          )}
        </div>
      )}
    </header>
  );
}
